function Article1() {
    return <p>En cours de réalisation...</p>
}

export default Article1